/**
 * Work Order execution_scope helpers (mirrors backend manufacturing/utils/execution-scope.ts).
 */

export type OperationGenerationMode = 'unit_wise' | 'boq_line';

export type DeliveryExecutionMode = 'unit_wise' | 'boq_line';

export function isFabricationExecutionScope(scope?: string | null): boolean {
  return String(scope ?? '').trim() === 'Fabrication';
}

export function isUnitWiseOperationGeneration(scope?: string | null): boolean {
  return isFabricationExecutionScope(scope);
}

export function getOperationGenerationMode(scope?: string | null): OperationGenerationMode {
  return isUnitWiseOperationGeneration(scope) ? 'unit_wise' : 'boq_line';
}

export function getOperationGenerationModeLabel(scope?: string | null): string {
  return isUnitWiseOperationGeneration(scope)
    ? 'Unit-wise (Fabrication)'
    : 'BOQ-line (total quantity)';
}

export function resolveDeliveryExecutionMode(input: {
  execution_scope?: string | null;
  operation_generation_mode?: OperationGenerationMode | null;
  hasUnitWiseStages?: boolean;
}): DeliveryExecutionMode {
  if (input.operation_generation_mode === 'unit_wise' || input.operation_generation_mode === 'boq_line') {
    return input.operation_generation_mode;
  }
  const scope = input.execution_scope;
  if (scope != null && String(scope).trim() !== '') {
    return isFabricationExecutionScope(scope) ? 'unit_wise' : 'boq_line';
  }
  if (input.hasUnitWiseStages) {
    return 'unit_wise';
  }
  return 'boq_line';
}

export function requiresFullLineDelivery(mode: DeliveryExecutionMode): boolean {
  return mode === 'boq_line';
}
